import { useInvestmentStore } from '@/stores';

const isInvestmentResource = (resourceType?: string) =>
    resourceType === 'investment' || resourceType === 'investments';

export const useWorkspaceResourceWebsite = (
    resourceType?: string,
    resourceId?: string,
    website?: string,
) => {
    const cachedWebsite = useInvestmentStore((state) => {
        if (!isInvestmentResource(resourceType) || !resourceId) {
            return undefined;
        }

        return (
            state.investments.find((investment) => investment.id === resourceId)?.website ??
            (state.selectedInvestment?.id === resourceId ? state.selectedInvestment.website : undefined)
        );
    });

    return website?.trim() || cachedWebsite;
};
